export const Input = {
  baseStyle: {},
  defaultProps: {
    size: 'md',
  },
  sizes: {
    sm: {
      field: {
        paddingInlineEnd: 'min(48px, 20%)',
        borderRadius: '8px',
        height: '40px',
        fontSize: 'md',
      },
      element: {
        height: '40px',
      },
    },
    md: {
      field: {
        paddingInlineEnd: 'min(48px, 20%)',
        borderRadius: '8px',
        height: '52px',
        fontSize: 'md',
      },
    },
  },
  variants: {
    outline: {
      field: {
        _focus: {
          borderWidth: '1px',
          borderColor: 'blue.700',
          boxShadow: 'focus',
        },
      },
    },
    success: {
      field: {
        borderWidth: '1px',
        boxShadow: 'success',
        _focus: {
          borderWidth: '1px',
          borderColor: 'green.500',
          boxShadow: 'success',
        },
      },
    },
    error: {
      field: {
        borderWidth: '1px',
        boxShadow: 'error',

        _focus: {
          borderWidth: '1px',
          borderColor: 'error.text',
          boxShadow: 'error',
        },
      },
    },
    disabled: {
      field: {
        borderColor: 'grey.background',
        pointerEvents: 'none',
        backgroundColor: 'grey.border',
        background: 'grey.border',
        color: 'grey.primaryText',
      },
    },
    ghost: {
      field: {
        backgroundColor: 'grey.white',
      },
    },
  },
};
